/* unplugin-vue-components disabled */
const __default__ = {
  props: {
    size: { 
      type: String,
      default: '1.6rem'
    },
  },
  emits: ['copy'],
  data() {
    return {
      copy: false,
    }
  },
  methods: {

    async onCopy(){
      if (this.copy) return
      this.copy = true
      this.$emit('copy')
      await $utils.timers.wait(2000)
      this.copy = false
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "bf6abdb6-size": (_ctx.size)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__